var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounFlight1606533222222(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M825.8,616.8L654.7,503.6V415c0-29.5-24.1-53.7-53.7-53.7s-53.7,24.1-53.7,53.7v88.6l-171,113.2 c-4.9,3-8,8.4-8,14.3v39.4c0,5.4,2.3,10.8,6.8,13.8c4.5,3.5,10.3,4,15.2,2.3L546.2,635v90l-56.5,39.8c-4.5,3.5-7.3,8.4-7.3,14.3 v42.4c0,5.4,3,10.8,7.3,14.3c3,1.9,6.3,3,9.8,3c1.9,0,4-0.5,5.9-0.9l94.5-34.5l94.5,31.9c5.4,1.9,10.8,0.9,15.7-2.3 c4.5-3.5,7.3-8.4,7.3-13.8v-39.4c0-5.4-3-10.8-7.3-14.3l-56.5-39.8v-90l155.9,51.6c5.4,1.9,10.8,0.9,15.2-2.3 c4.5-3.3,6.8-8.4,6.8-13.8v-39.4C833.1,625.3,830.5,619.9,825.8,616.8L825.8,616.8z M799.5,646.8h-0.9l-155.9-51.6 c-5.4-1.9-10.8-0.9-15.2,2.3c-4.5,3.5-6.8,8.4-6.8,13.8v123.2c0,5.4,3,10.8,7.3,14.3l56.5,39.8v6.3l-77.3-26c-3.5-1.4-8-0.9-11.2,0 L517.7,797v-8.4l56.5-39.8c4.5-3.5,7.3-8.4,7.3-14.3V611.4c0-5.4-2.3-10.8-6.8-13.8c-4.5-3.5-10.3-4-15.2-2.3l-156.3,51.6v-6.3 l170.9-113.3c4.9-3,8-8.4,8-14.3v-98c0-10.8,8.9-19.2,19.2-19.2s19.2,8.9,19.2,19.2v98c0,5.9,3,11.2,8,14.3l171,113.2V646.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounFlight1606533222222);
export default __webpack_public_path__ + "static/media/noun-flight-1606533-222222.96e3610454b7e9c5fa703933d84471c9.svg";
export { ForwardRef as ReactComponent };